module.exports = __webpack_public_path__ + "static/media/icono-total-ufs-kg.bea3b651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-total-ufs-kg.png
// module id = 293
// module chunks = 0